import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 公告列表
const noticeList = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.notice_list + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

// 创建公告
const noticeSend = obj => new Promise((resolve, reject) => {
    const {
        noticeForm,
        token
    } = obj
    request({
        url: apis.notice_send + '?token=' + token,
        data: noticeForm
    }).then(res => {
        resolve(res);
    })
})

// 编辑公告
const noticeEdit = obj => new Promise((resolve, reject) => {
    const {
        noticeForm,
        token
    } = obj
    request({
        url: apis.notice_edit + '?token=' + token ,
        data: noticeForm
    }).then(res => {
        resolve(res);
    })
})

// 删除公告
const noticeDelete = obj => new Promise((resolve, reject) => {
    const {
        noticeForm,
        token
    } = obj
    request({
        url: apis.notice_delete + '?token=' + token ,
        data: noticeForm
    }).then(res => {
        resolve(res);
    })
})

// 更新公告图
const modifyBanner = obj => new Promise((resolve, reject) => {
    const {
        noticePngForm,
        token
    } = obj
    request({
        url: apis.notice_banner_modify + '?token=' + token ,
        data: noticePngForm
    }).then(res => {
        resolve(res);
    })
})

// 公告图信息
const bannerInfo = token => new Promise((resolve, reject) => {
    request({
        url: apis.notice_banner_info + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

export default {
    noticeList,
    noticeSend,
    noticeEdit,
    noticeDelete,
    modifyBanner,
    bannerInfo
}



// WEBPACK FOOTER //
// ./src/service/notice_api.js